import { URLState } from '../../../models';
import { URL_MUTATIONS_KEYS } from '../url.const';
import { URLMutation } from '../url.interfaces';

export class SetUrlMutation implements URLMutation {
  mutations = {
    [URL_MUTATIONS_KEYS.setURL]: (urlState: URLState, newURL: string) => {
      urlState.url = newURL;
    }
  };
}
